/** CSS contract: css-library/components/01-leaves/item-number.css. */
import type { ComponentProps } from 'react';
import { cx } from '../lib/cx';

export type ItemNumberProps = ComponentProps<'span'>;

export function ItemNumber({ className, ...props }: ItemNumberProps) {
  return <span className={cx('item-number', className)} {...props} />;
}
